import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'

const config: SkyNetTableConfig = {
    name: 'UserTable',
    tabs: [{
        name: 'All Users',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'userName',
                labelKey: 'Users.userName',
                reduced: true,
            },
            {
                name: 'email',
                labelKey: 'Contact.email',
            },
            {
                name: 'locationLocationName',
                labelKey: 'Contact.location',
                filterType: FilterType.Array,
            },
        ],
    }],
}

export default config
